import { FC } from 'react';
import { useSelector } from 'react-redux';

import { Typography } from '@beeline/design-system-react/extracted-styles';

import { getAdminState } from 'src/store/admin/selectors';

export const AdministratorBuildingSidesheetTitle: FC = () => {
  const { selectedBuildingId } = useSelector(getAdminState);

  return (
    <Typography variant='h5' data-testid='administratorSideSheetTitle'>
      {selectedBuildingId ? 'Редактирование офиса' : 'Создание офиса'}
    </Typography>
  );
};
